import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const Typography = ({ variant = 'body', children, color = 'inherit', align = 'left', className = '', ...props }) => {
  const Element =
    {
      h1: 'h1',
      h2: 'h2',
      h3: 'h3',
      h4: 'h4',
      h5: 'h5',
      h6: 'h6',
      body: 'p',
      caption: 'span',
      // Default to span for unrecognized variants
    }[variant] || 'span'

  const variantClasses = {
    h1: 'text-4xl font-bold leading-tight md:text-[1.75rem]',
    h2: 'text-3xl font-semibold leading-snug md:text-[1.5rem]',
    h3: 'text-2xl font-medium leading-[1.3] md:text-[1.25rem]',
    h4: 'text-xl font-medium leading-[1.35] md:text-[1rem]',
    h5: 'text-lg font-medium leading-[1.4] md:text-[0.875rem]',
    h6: 'text-base font-medium leading-[1.45] md:text-[0.75rem]',
    body: 'text-base font-normal leading-relaxed',
    caption: 'text-sm font-normal leading-relaxed text-secondary',
  }

  const colorClasses = {
    primary: 'text-primary',
    secondary: 'text-gray-600',
    success: 'text-success',
    danger: 'text-danger',
    warning: 'text-yellow-500',
    info: 'text-cyan-600',
    light: 'text-gray-200',
    dark: 'text-dark',
    inherit: '',
  }

  const alignClasses = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
    justify: 'text-justify',
  }

  return (
    <Element className={clsx(variantClasses[variant], colorClasses[color], alignClasses[align], className)} {...props}>
      {children}
    </Element>
  )
}

Typography.propTypes = {
  variant: PropTypes.string,
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  align: PropTypes.string,
  className: PropTypes.string,
}

export default Typography
